import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import { useRouter } from "next/router";
import React from "react";

const PAGE_HAS_FOOTER = ["", ResourceCodeEnums.HOME];

const Footer = () => {
  const router = useRouter();

  if (
    !PAGE_HAS_FOOTER.some(
      (item) =>
        router.pathname.startsWith(`/${item}/`) ||
        router.pathname === `/${item}`
    )
  ) {
    return null;
  }

  return (
    <div className="p-6 text-center text-sm text-text-black/[.5]">
      <div>
        Copyright 2015-2023 pinduoduo.com
        版权所有（增值电信业务经营许可证：沪B2-20170215）
      </div>
      <div>
        <span
          className="cursor-pointer"
          onClick={() =>
            window.open(
              "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502000392"
            )
          }
        >
          沪公网安备 31010502000392 号
        </span>
        沪ICP备15010535号-13
      </div>
    </div>
  );
};

export default Footer;
